// Utility function to group photos by date
import pako from "pako";
import CryptoJS from "crypto-js";
import { CRYPTO_SECRET } from "../constants";
export const groupPhotosByDate = (photos) => {
  return photos.reduce((groups, photo) => {
    const { date } = photo;
    if (!groups[date]) {
      groups[date] = [];
    }
    groups[date].push(photo);
    return groups;
  }, {});
};
export { cssFontFamily } from "./cssFontFamily";

export const getMonthYear = (startMonth, startYear, pageIndex) => {
  let month = startMonth + pageIndex;
  let year = startYear;

  if (month > 12) {
    // Calculate how many years to add
    const yearsToAdd = Math.floor((month - 1) / 12);
    // Calculate the new month (1-12 range)
    month = ((month - 1) % 12) + 1;
    // Add the calculated years
    year += yearsToAdd;
  }

  return { month, year };
};

export const hasAllClasses = (element, classes) => {
  return classes.every((cls) => element.classList.contains(cls));
};
export const hasAnyClass = (element, classes) => {
  return classes.some((cls) => element.classList.contains(cls));
};

export const getResolutionScaleValue = (width, height, wrapper) => {
  if (!wrapper) {
    return null;
  }
  const sizeAspectRatio = width / height;
  const wrapperRect = wrapper.getBoundingClientRect(); // available width and height to set new canvas size
  let containerWidth = wrapperRect.width;

  let containerHeight = wrapperRect.height - 15; // add some space for shadow

  const containerAspectRatio = containerWidth / containerHeight;

  let newWidth = 0,
    newHeight = 0;
  if (sizeAspectRatio > containerAspectRatio) {
    // Width is the limiting factor
    newWidth = containerWidth;
    newHeight = containerWidth / sizeAspectRatio;
  } else {
    // Height is the limiting factor
    newHeight = containerHeight;
    newWidth = containerHeight * sizeAspectRatio;
  }

  return { newWidth, newHeight };
};
export const getResolutionScaleValueBySize = (
  width,
  height,
  containerWidth,
  containerHeight
) => {
  const sizeAspectRatio = width / height;

  const containerAspectRatio = containerWidth / containerHeight;

  let newWidth = 0,
    newHeight = 0;
  if (sizeAspectRatio > containerAspectRatio) {
    // Width is the limiting factor
    newWidth = containerWidth;
    newHeight = containerWidth / sizeAspectRatio;
  } else {
    // Height is the limiting factor
    newHeight = containerHeight;
    newWidth = containerHeight * sizeAspectRatio;
  }

  return { width: newWidth, height: newHeight };
};

// Function to calculate the zoom ratio
export const calculateZoomRatio = (
  originalWidth,
  originalHeight,
  newWidth,
  newHeight
) => {
  const widthScale = newWidth / originalWidth;
  const heightScale = newHeight / originalHeight;
  return Math.min(widthScale, heightScale);
};
/*
 * @param {number} width - actual width
 * @param {number} height - actual height
 * @param {number} wrapperWidth - width of the wrapper
 * @param {number} wrapperHeight - height of the wrapper
 */
export const getScaledValues = (width, height, wrapperWidth, wrapperHeight) => {
  const sizeAspectRatio = width / height;
  const containerAspectRatio = wrapperWidth / wrapperHeight;

  let newWidth = 0,
    newHeight = 0;
  if (sizeAspectRatio > containerAspectRatio) {
    // Width is the limiting factor
    newWidth = wrapperWidth;
    newHeight = wrapperWidth / sizeAspectRatio;
  } else {
    // Height is the limiting factor
    newHeight = wrapperHeight;
    newWidth = wrapperHeight * sizeAspectRatio;
  }

  return { newWidth, newHeight };
};

export const getPhotoBookPagelabel = (index, totalPages) => {
  if (index === 0) {
    return "Front Cover";
  }
  if (index === totalPages - 1) {
    return "Back Cover";
  }
  let pageLabel = "";
  if (index * 2 - 2 !== 0) {
    pageLabel = index * 2 - 2 + (index !== totalPages - 2 ? "-" : "");
  }
  if (index !== totalPages - 2) {
    pageLabel = pageLabel + (index * 2 - 1);
  }
  return "Page " + pageLabel;
};
export const getPageLabelForTwoSideProduct = (index) => {
  if (index === 0) {
    return "Front Side";
  }
  if (index === 1) {
    return "Back Side";
  }
  return "";
};
export const getPageLabel = (index, totalPages) => {
  return index + 1;
};

export const hexToRgba = (hex, alpha) => {
  hex = hex.replace("#", "");
  const r = parseInt(hex.substring(0, 2), 16);
  const g = parseInt(hex.substring(2, 4), 16);
  const b = parseInt(hex.substring(4, 6), 16);

  return `rgba(${r}, ${g}, ${b}, ${alpha})`;
};

// Helper function to convert Uint8Array to base64
function uint8ArrayToBase64(uint8Array) {
  let binary = "";
  const bytes = new Uint8Array(uint8Array);
  const len = bytes.byteLength;
  for (let i = 0; i < len; i++) {
    binary += String.fromCharCode(bytes[i]);
  }
  return btoa(binary);
}
// Function to compress and convert to base64
export const compressData = (jsonString) => {
  // Step 1: Compress the JSON string
  // console.log("jsonString:", jsonString);
  const compressed = pako.gzip(jsonString);

  // Step 2: Convert compressed data to base64 string
  //const base64String = btoa(String.fromCharCode(...new Uint8Array(compressed)));
  const base64String = uint8ArrayToBase64(new Uint8Array(compressed));

  return base64String;
};
// decompress the data and return the layout to call  const decompressedLayouts = loadLayout(compressed);
// Function to decompress from base64 string
export function decompressFromBase64(base64String) {
  try {
    // Convert base64 to Uint8Array
    const compressedBytes = base64ToUint8Array(base64String);

    // Decompress the data using pako
    const decompressed = pako.ungzip(compressedBytes, { to: "string" });

    // Convert decompressed string back to JSON
    const jsonData = JSON.parse(decompressed);

    // console.log("Decompressed JSON Data:", jsonData);
    return jsonData;
  } catch (err) {
    console.error("Decompression Error: ", err);
  }
}
// Helper function to convert base64 to Uint8Array
function base64ToUint8Array(base64) {
  const binaryString = atob(base64);
  const len = binaryString.length;
  const bytes = new Uint8Array(len);
  for (let i = 0; i < len; i++) {
    bytes[i] = binaryString.charCodeAt(i);
  }
  return bytes;
}
export const scalePages = (pages, newWidth, newHeight) => {
  pages.forEach((page, pageindex) => {
    page.layout.forEach((item, index) => {
      // console.log("Item details"+item.width, item.height);
      //const newWidth = canvasSize.width / 2;
      // const newHeight = canvasSize.height;
      if (item !== null) {
        scaleLayout(item, newWidth, newHeight);
      }

      //  decompressedTheme.pages[pageindex].layout[index] = cp;
    });
  });
  return pages;
};

export const calculateNewFontSize = (
  oldFontSize,
  oldWidth,
  oldHeight,
  newWidth,
  newHeight,
  mode = "average"
) => {
  let scaleFactor;

  if (mode === "width") {
    scaleFactor = newWidth / oldWidth;
  } else if (mode === "height") {
    scaleFactor = newHeight / oldHeight;
  } else if (mode === "average") {
    scaleFactor = Math.sqrt((newWidth / oldWidth) * (newHeight / oldHeight));
    // console.log("oldwidth scaleFactor:", oldFontSize, scaleFactor);
  } else {
    return 1;
  }

  return oldFontSize * scaleFactor;
};

// Function to scale a single layout object (same as before)
export const scaleLayout = (layout, newWidth, newHeight) => {
  //create a copy of the layout object
  // console.log("original layout:", layout);
  // let layout = JSON.parse(JSON.stringify(layout));


  const originalWidth = layout.width;
  const originalHeight = layout.height;

  const widthScale = newWidth / originalWidth;
  const heightScale = newHeight / originalHeight;

  // Update layout dimensions
  layout.width = newWidth;
  layout.height = newHeight;

  // Two factors for the things that must NOT be stretched per-axis. Both
  // collapse to the same number when the aspect ratio is unchanged, so a
  // same-aspect resize is an exact similarity transform (pixel perfect).
  //
  //   uniform — type size, stroke widths, blur radii, cell gaps. The geometric
  //             mean is what calculateNewFontSize's "average" mode uses (and
  //             what Header.jsx already applies to calendar type on a size
  //             switch), and it is the only factor that keeps type at the same
  //             PHYSICAL size across an aspect flip: 12x8 → 8x12 is the same
  //             area and the same paper, so sqrt(0.667 * 1.5) = 1 leaves the
  //             type alone. Math.min would shrink it by a third for nothing,
  //             which is exactly the "fonts came out smaller" report.
  //   cover   — a photo must still fill its frame on BOTH axes, so it takes the
  //             larger factor; the smaller one would leave a gap at the edge.
  //
  // ponytail: on a big aspect flip a text box narrows while its type holds size,
  // so a long line wraps to more lines (the box is taller, so there is room).
  // If a real design ever clips, fix it by growing the text box, not by
  // shrinking the type back.
  const uniform = Math.sqrt(widthScale * heightScale);
  const cover = Math.max(widthScale, heightScale);

  // scaleObject multiplies in place, so scaling one object twice would square
  // the factor. objects and safeAreaObjects are separate lists, but this makes
  // a shared reference between them harmless instead of a silent double-scale.
  const alreadyScaled = new WeakSet();

  // Scale each object in the layout
  const scaleObject = (obj) => {
    if (!obj || typeof obj !== "object") return obj;
    if (alreadyScaled.has(obj)) return obj;
    alreadyScaled.add(obj);

    // Frame size BEFORE scaling; the inner-image remap below needs it. Defaulted
    // because an object missing width/height would turn the remap into NaN and
    // silently blank the photo's position.
    const frameWidth = Number(obj.width) || 0;
    const frameHeight = Number(obj.height) || 0;

    // Scale width and height of the object
    obj.width *= widthScale;
    obj.height *= heightScale;

    // Scale position (x, y) in transform
    if (obj.transform) {
      obj.transform.x *= widthScale;
      obj.transform.y *= heightScale;
    }
    // Font size lives at obj.font.size — obj.text is the text CONTENT (a string),
    // so the old `obj.text.fontSize` was always undefined and text never scaled
    // at all: a design moved to a bigger size kept 16px type on a 2x canvas.
    // parseFloat, not Number: Text.jsx reads this with parseInt, so saved data
    // may carry a unit suffix ("16px"), and Number() would turn that into NaN
    // and erase the text.
    if (obj.font && obj.font.size) {
      const size = parseFloat(obj.font.size);
      if (Number.isFinite(size)) obj.font.size = size * uniform;
    }
    if (
      obj.type === "img" &&
      obj.image &&
      obj.image.width &&
      obj.image.height
    ) {
      // image.width/height is the BASE bitmap size and image.scale is the cover
      // factor on top of it (see objectResize.js, which derives the minimum
      // scale as newWidth / image.width). So the zoom scales, the base does not.
      obj.image.scale *= cover;

      // positionX/Y is the pan offset of that bitmap inside the frame, in canvas
      // units — it was left untouched, so a rescaled photo kept its OLD offset
      // against a new, differently-sized frame and the crop visibly slid (worse
      // the further the photo had been panned). Remap it so the point of the
      // photo that sat at the frame centre stays at the frame centre:
      //   u = (F/2 - p) / I  must hold before and after, with I scaled by cover.
      // On a same-aspect resize this reduces exactly to p * scale.
      const panX = Number(obj.image.positionX) || 0;
      const panY = Number(obj.image.positionY) || 0;
      obj.image.positionX =
        (widthScale * frameWidth) / 2 - cover * (frameWidth / 2 - panX);
      obj.image.positionY =
        (heightScale * frameHeight) / 2 - cover * (frameHeight / 2 - panY);
    }

    // Scale shadow properties if present. The old guard tested obj.shadow.offset,
    // a nested {x,y} shape that the renderers do not use (Photo/Shape/Sticker all
    // read the flat offsetX/offsetY/blurRadius), so shadows never scaled either.
    if (obj.shadow) {
      if (obj.shadow.offsetX) obj.shadow.offsetX *= widthScale;
      if (obj.shadow.offsetY) obj.shadow.offsetY *= heightScale;
      if (obj.shadow.blurRadius) obj.shadow.blurRadius *= uniform;
      if (obj.shadow.spread) obj.shadow.spread *= uniform;
    }

    // Border width is an absolute stroke width in canvas units. Text keeps its
    // border under obj.style.border, everything else at obj.border. A Set so an
    // object holding the SAME border object at both paths is scaled once.
    new Set([obj.border, obj.style?.border]).forEach((border) => {
      if (!border) return;
      if (border.width) border.width *= uniform;
      // Corner radius is only absolute for text (rx) and shape (rx * scaleX).
      // Photo.jsx and Sticker.jsx both render it RELATIVE, as
      // item.width * radius / 24, so the frame growing already grows the corner;
      // scaling it here would apply the factor twice. Allowlist rather than
      // exclude, so an unlisted type keeps the old (unscaled) behaviour.
      if (border.radius && (obj.type === "text" || obj.type === "shape")) {
        border.radius *= uniform;
      }
    });

    // Calendar grids size their cells from the object box, but the type size and
    // the gaps between cells are absolute canvas units. (The GLOBAL calendar
    // settings are scaled separately by Header.jsx on a size switch; this is the
    // per-object override, which nothing else touches.)
    const cal = obj.calendarSettings;
    if (cal) {
      const scaleNumeric = (value, factor) => {
        const n = parseFloat(value);
        return Number.isFinite(n) ? n * factor : value;
      };
      if (cal.fontSize) cal.fontSize = scaleNumeric(cal.fontSize, uniform);
      if (cal.cellMargin) cal.cellMargin = scaleNumeric(cal.cellMargin, uniform);
      if (cal.borderWidth) cal.borderWidth = scaleNumeric(cal.borderWidth, uniform);
    }

    // Scale masking properties if present
    if (obj.masking && obj.masking.width && obj.masking.height) {
      // console.log("masking:", obj.masking);

      if (
        obj.masking.path &&
        obj.masking.path !== null &&
        obj.masking.path !== "M0 0 L24 0 L24 24 L0 24 Z"
      ) {
        // Skip scaling for rectangle mask
        // obj.masking.width *= widthScale;
        //obj.masking.height *= heightScale;  // this is creating issue in masking because width and heigh is based on path
      }
    }

    return obj;
  };

  layout.objects = layout.objects.map(scaleObject);
  // Safe-area objects are real canvas objects too (getMaskIds, patchPendingImageObjects
  // and the export walk them); leaving them unscaled stranded them at the old
  // coordinates on every rescale, not just the cart-size one.
  if (Array.isArray(layout.safeAreaObjects)) {
    layout.safeAreaObjects = layout.safeAreaObjects.map(scaleObject);
  }
  // console.log("converted layout:", layout);
  return layout;
};

export const getMaskIds = (pages) => {
  const maskIds = [];

  pages.forEach((page) => {
    page.layout.forEach((layout) => {
      //lets continue if layout is null
      if (layout === null) {
        return;
      }
      layout.objects.forEach((obj) => {
        if (obj.type === "img" && obj.masking && obj.masking.mask_id) {
          maskIds.push(obj.masking.mask_id);
        }
      });
      layout?.safeAreaObjects?.forEach((obj) => {
        if (obj.type === "img" && obj.masking && obj.masking.mask_id) {
          maskIds.push(obj.masking.mask_id);
        }
      });
    });
  });
  return maskIds;
};
export const replaceMaskIdWithPath = (pages, maskDetails) => {
  // pages IS READ ONLY, LETS MAKE COPY OF IT AND RETURN AFTER MODIFICATION
  let pagesCopy = JSON.parse(JSON.stringify(pages));
  maskDetails.forEach((item) => {
    pagesCopy.forEach((page) => {
      page.layout.forEach((layout) => {
        if (!layout) return; // skip null layout entries
        layout.objects.forEach((obj) => {
          if (
            obj.type === "img" &&
            obj.masking &&
            obj.masking.mask_id &&
            obj.masking.mask_id === item._id
          ) {
            obj.masking.path = item.urls[0].d;
          }
        });
        layout?.safeAreaObjects?.forEach((obj) => {
          if (
            obj.type === "img" &&
            obj.masking &&
            obj.masking.mask_id &&
            obj.masking.mask_id === item._id
          ) {
            obj.masking.path = item.urls[0].d;
          }
        });
      });
    });
  });
  return pagesCopy;
};

export const Encrypt = (data) => {
  return CryptoJS.AES.encrypt(JSON.stringify(data), CRYPTO_SECRET).toString();
};

export const Decrypt = (data) => {
  return CryptoJS.AES.decrypt(data, CRYPTO_SECRET).toString(CryptoJS.enc.Utf8);
};

// function to check image quality
export const isLowQuality = (
  imageWidth,
  imageHeight,
  placeholderWidthInches,
  placeholderHeightInches,
  minPPI = 300
) => {
  const requiredWidth = placeholderWidthInches * minPPI;
  const requiredHeight = placeholderHeightInches * minPPI;
  return imageWidth < requiredWidth || imageHeight < requiredHeight;
};

export const checkImagePrintQuality = (
  imageWidth, // original image width in px
  imageHeight, // original image height in px
  placeholderWidth, // placeholder width in px
  placeholderHeight, // placeholder height in px
  zoomFactor = 1,
  canvasDPI = 200,
  minDPI = 100, // minimum DPI threshold for good quality
  autoFit = true // flag to indicate image is auto-fitted to fill placeholder
) => {
  // 1. Auto-fit zoom factor to cover placeholder
  let fitZoom = 1;
  if (autoFit) {
    const fitZoomW = placeholderWidth / imageWidth;
    const fitZoomH = placeholderHeight / imageHeight;
    fitZoom = Math.max(fitZoomW, fitZoomH);
  }

  // 2. Total applied zoom = autoFit zoom * zoomFactor
  const totalZoom = fitZoom * zoomFactor;

  // 3. Scaled image size
  const scaledImageWidth = imageWidth * totalZoom;
  const scaledImageHeight = imageHeight * totalZoom;

  // Portion of image shown inside placeholder (in % of original image)
  const usedImageWidth = (placeholderWidth / scaledImageWidth) * imageWidth;
  const usedImageHeight = (placeholderHeight / scaledImageHeight) * imageHeight;

  // Placeholder size in inches (based on canvas DPI)
  const placeholderWidthInch = placeholderWidth / canvasDPI;
  const placeholderHeightInch = placeholderHeight / canvasDPI;

  // Effective DPI
  const dpiX = usedImageWidth / placeholderWidthInch;
  const dpiY = usedImageHeight / placeholderHeightInch;
  const effectiveDPI = Math.min(dpiX, dpiY);

  // Quality Status
  let quality = "good";
  if (effectiveDPI < minDPI) {
    quality = "poor";
  } else if (effectiveDPI < canvasDPI) {
    quality = "low";
  } else if (effectiveDPI > 600) {
    quality = "high";
  }

  return quality;
};

export const getPageLabelForFoldableProduct = (
  index,
  allPagesSettings = []
) => {
  let pageCount = 0;

  // Sum page count before the current index
  for (let i = 0; i < index; i++) {
    const item = allPagesSettings[i];
    if (item?.isHalfSheet) {
      pageCount += 1;
    } else {
      pageCount += 2;
    }
  }

  const currentItem = allPagesSettings[index];
  if (currentItem?.isHalfSheet) {
    return `Page ${pageCount + 1}`;
  } else {
    return `Page ${pageCount + 1} - ${pageCount + 2}`;
  }
};
export const getPageLabelForLayflatWithCover = (
  index,
  totalPages,
  fullSheetCover = false
) => {
  if (!fullSheetCover) {
    if (index === 0) return "Front Cover";
    if (index === totalPages - 1) return "Back Cover";
  } else {
    if (index === 0) return "Cover";
  }

  // Middle spreads
  const spreadNumber = index; // since index 1 => first spread
  const startPage = (spreadNumber - 1) * 2 + 1;
  const endPage = startPage + 1;

  return `Page ${startPage}-${endPage}`;
};

export const getDynamicStartYear = () => {
  const currentDate = new Date();
  const currentMonthIndex = currentDate.getMonth();
  const currentYear = currentDate.getFullYear();

  if (currentMonthIndex >= 9) {
    return currentYear + 1;
  } else {
    return currentYear;
  }
};

export const handleImageUploadLimit = ({
  settings,
  totalUploadedImages,
  user,
  selectedCount,
  userTypeCustomer,
  dispatch,
  setLimitReachedAction,
  actionType = "upload",
}) => {
  const maxLimit = settings?.maxImageUploadLimit || 0;
  const applyMaximumImageUploadLimit = settings?.applyMaximumImageUploadLimit;
  const isCustomer = user?.userTypeCode === userTypeCustomer;

  // Check if limit should be applied
  const shouldApplyLimit =
    isCustomer && applyMaximumImageUploadLimit === true && maxLimit > 0;

  if (!shouldApplyLimit) {
    return {
      shouldStop: false,
      allowedCount: selectedCount,
      isLimitReached: false,
      remainingSlots: Infinity,
      skippedCount: 0,
      maxLimit: 0,
    };
  }

  const remainingSlots = Math.max(0, maxLimit - totalUploadedImages);
  const isLimitReached = remainingSlots <= 0;
  const allowedCount = Math.min(selectedCount, remainingSlots);
  const skippedCount = selectedCount - allowedCount;

  const actionVerb =
    actionType === "add"
      ? "add"
      : actionType === "import"
        ? "import"
        : "upload";

  if (isLimitReached) {
    dispatch(setLimitReachedAction(true));
    alert(
      `You have reached the maximum limit of ${maxLimit} images. You cannot ${actionVerb} more images.`
    );

    return {
      shouldStop: true,
      allowedCount: 0,
      isLimitReached: true,
      remainingSlots: 0,
      skippedCount: selectedCount,
      maxLimit,
    };
  }

  if (skippedCount > 0) {
    alert(
      `You can only ${actionVerb} ${remainingSlots} more image(s). ${skippedCount} image(s) will be skipped to stay within the limit of ${maxLimit} images.`
    );
  }

  return {
    shouldStop: false,
    allowedCount,
    isLimitReached: false,
    remainingSlots,
    skippedCount,
    maxLimit,
  };
};

// ── Per-image upload size limit ─────────────────────────────────────
// The backend rejects originals larger than 30 MB; validating on the
// client avoids wasting bandwidth + a resize pass on a file that would
// be refused. Applies to the ORIGINAL selected file (pre-resize).
export const MAX_IMAGE_UPLOAD_MB = 30;
export const MAX_IMAGE_UPLOAD_BYTES = MAX_IMAGE_UPLOAD_MB * 1024 * 1024;

/**
 * Split an array of File/Blob into those within the size limit and those
 * over it. A missing/unknown size is treated as valid (never block on
 * uncertainty — the backend is the final gate).
 *
 * @param {Array<File|Blob>} files
 * @param {number} [maxBytes=MAX_IMAGE_UPLOAD_BYTES]
 * @returns {{ valid: File[], oversized: File[] }}
 */
export const filterOversizedImages = (files, maxBytes = MAX_IMAGE_UPLOAD_BYTES) => {
  const valid = [];
  const oversized = [];
  (files || []).forEach((file) => {
    if (file && typeof file.size === "number" && file.size > maxBytes) {
      oversized.push(file);
    } else {
      valid.push(file);
    }
  });
  return { valid, oversized };
};

/**
 * Human-readable "these were skipped" message, or "" when nothing skipped.
 * Lists up to 5 names so the alert stays readable for large batches.
 */
export const buildOversizedAlert = (oversized, maxMB = MAX_IMAGE_UPLOAD_MB) => {
  if (!oversized || oversized.length === 0) return "";
  const names = oversized
    .slice(0, 5)
    .map((f) => f?.name || "image")
    .join(", ");
  const more = oversized.length > 5 ? ` and ${oversized.length - 5} more` : "";
  return (
    `${oversized.length} image(s) larger than ${maxMB}MB were skipped` +
    ` (${names}${more}). Please upload images under ${maxMB}MB.`
  );
};

// Re-export generatePageSvg for convenience
export { generatePageSvg } from "./generatePageSvg.js";
